import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    /* Restore Roboto as the app font. Keep fallback to Arial/system sans-serif. */
    @font-face {
        font-family: 'Roboto';
        src: url('/fonts/Roboto-Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Roboto';
        src: url('/fonts/Roboto-Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
    }

    /* Present Mode screens (Inter 4.1, SIL OFL, see /fonts/Inter-LICENSE.txt).
       Only downloaded when a page actually uses it. */
    @font-face {
        font-family: 'Inter';
        src: url('/fonts/InterVariable.woff2') format('woff2');
        font-weight: 100 900;
        font-style: normal;
        font-display: swap;
    }

    html {
        --app-font-size: 100%;
    }

    body {
        font-family: 'Roboto', Arial, sans-serif;
        background-color: #334768;
        margin: 0;
        overflow: visible !important;
        padding-right: 0px !important;
        font-size: var(--app-font-size, 100%);
    }

    @media (max-width: 768px) {
        html.lang-de {
            --app-font-size: 93.75%;
        }
    }

    /* Hide native scrollbar only for the channels sidebar container */
    .sidebar-scroll-container {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
    }

    .sidebar-scroll-container::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    .sidebar-scroll-container::-webkit-scrollbar-thumb {
        background: transparent;
    }

`;

export default GlobalStyle;
